import { render, staticRenderFns } from "./OverviewList.vue?vue&type=template&id=1227245c&lang=pug"
import script from "./OverviewList.vue?vue&type=script&lang=js"
export * from "./OverviewList.vue?vue&type=script&lang=js"
import style0 from "./OverviewList.vue?vue&type=style&index=0&id=1227245c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports